import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { localStorageService } from '../../services/local-storage.service';
import { requestLoginWithSessionId } from '../../store/modules/auth/actions';
import { Loading } from '../report/shared/components/Loading';

export function RedirectPage() {
  const dispatch = useDispatch();

  const [isValidatingSessionId, setIsValidatingSessionId] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get('sessionId');
  const toPath = urlParams.get('toPath');

  const validateLoginBySessionIdFromNewSpa = async (sessionId: string) => {
    dispatch(requestLoginWithSessionId(sessionId));
  };

  useEffect(() => {
    localStorageService.removeLocalStorageItem({
      key: 'user_token_login_info',
    });

    const handleSessionId = async () => {
      try {
        if (sessionId) {
          const response = await validateLoginBySessionIdFromNewSpa(sessionId);

          setIsValidatingSessionId(true);
        }
      } catch (error) {
        setIsValidatingSessionId(false);
        console.error('error: ', error);
      }
    };

    handleSessionId();
  }, [sessionId]);

  useEffect(() => {
    const legacy_token = localStorageService.getLocalStorageItem({
      key: 'user_token_login_info',
    })?.legacy_token;

    if (isValidatingSessionId && legacy_token && toPath) {
      window.location.replace(toPath);
    }
  }, [isValidatingSessionId]);

  return (
    <div
      style={{
        width: '100dvw',
        height: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loading />
    </div>
  );
}
